module.exports = require("./fr-BF.d.ts");